import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Button, CircularProgress, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../../assets/images/logo.png';

export default function SetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async () => {
    if (!password || !confirmPassword) return toast.error('Please fill all fields');
    if (password.length < 6) return toast.error('Password must be at least 6 characters');
    if (password !== confirmPassword) return toast.error('Passwords do not match');

    setIsLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/center/setPassword`, { token, password });
      toast.success('Password created successfully! You can now log in.');
      setDone(true);
      setTimeout(() => navigate('/center-login'), 2500);
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.error || 'Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #ece9e6, #ffffff)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 420,
          borderRadius: 4,
          textAlign: 'center',
        }}
      >
        <img src={logo} alt="Logo" style={{ width: '120px', marginBottom: 8 }} />

        <Typography fontWeight="bold" sx={{ color: 'rgb(59 55 65)', mb: 1, fontSize: '24px' }}>
          Create Your Password
        </Typography>

        <Typography variant="body2" sx={{ mb: 3, color: 'gray' }}>
          Set a secure password to activate your account
        </Typography>

        {done ? (
          <Box sx={{ py: 3 }}>
            <Typography color="success.main" fontWeight="bold" fontSize={16}>
              Password created! Redirecting to login...
            </Typography>
          </Box>
        ) : (
          <>
            <TextField
              placeholder="New Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              sx={{ mb: 2, '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 13 } }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((v) => !v)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              placeholder="Confirm Password"
              type={showConfirm ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              sx={{ mb: 3, '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 13 } }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirm((v) => !v)} edge="end">
                      {showConfirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              fullWidth
              disabled={isLoading}
              onClick={handleSubmit}
              sx={{
                backgroundColor: 'rgb(59 55 65)',
                p: 1.2,
                fontSize: '13px',
                fontWeight: 'bold',
                borderRadius: '10px',
                '&:hover': { backgroundColor: 'rgb(80, 75, 90)' },
              }}
            >
              {isLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Set Password & Activate Account'}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
